import { MapsAPILoader } from '@agm/core';
import { NgForOf, NgIf } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Account } from '@core/auth/account.model';
import { AccountService } from '@core/auth/account.service';
import { PersonService } from '@core/user/person.service';
import { NotificationService } from '@flowinn/services/notification.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { QuestionService } from '@geracaoz/question/question.service';
import { RegistrationService } from '@geracaoz/registration/registration.service';
import { TranslateDirective } from '@language/translate.directive';
import { IForeignAddressClient } from '@model/client/foreign-address-client.model';
import { IPersonRelationshipClient } from '@model/client/person-relationship-client.model';
import { IPersonToInstitutionEntityFunctionClient } from '@model/client/person-to-institution-entity-function-client.model';
import { IPersonYoung } from '@model/client/person-young.model';
import { IPortugueseAddressClient } from '@model/client/portuguese-address-client.model';
import { ISectorIdentificationClient } from '@model/client/sector-identification-client.model';
import { ProgramEnum } from '@model/enumerations/program-enum.model';
import { RegistrationType } from '@model/enumerations/registration-type.model';
import { YoungRegistrationState } from '@model/enumerations/young-registration-state.model';
import { Answer, IAnswer } from '@model/geracaoz/answer.model';
import { ICandidatureFrontendGeracaoz } from '@model/geracaoz/candidature-frontend.model';
import { ILocation } from '@model/geracaoz/location.model';
import { IQuestion } from '@model/geracaoz/question.model';
import { IRegistration, Registration } from '@model/geracaoz/registration.model';
import { ITask } from '@model/geracaoz/task.model';
import { IProgramEdition } from '@model/program-edition.model';
import { TranslateModule } from '@ngx-translate/core';
import { ProgramEditionService } from '@programs/program-edition/program-edition.service';
import { SharedDataService } from '@services/shared-data-service';
import { PersonValidatorService } from '@util/person-validator.service';
import { NgWizardConfig, NgWizardModule, NgWizardService, STEP_STATE, StepChangedArgs, THEME } from 'ng-wizard';
import { OrderModule } from 'ngx-order-pipe';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'jhi-geracaoz-candidature-inscription',
  templateUrl: './geracaoz-candidature-inscription.component.html',
  imports: [
    NgWizardModule,
    TableModule,
    FontAwesomeModule,
    TooltipModule,
    NgIf,
    TranslateModule,
    NgForOf,
    OrderModule,
    FormsModule,
    TranslateDirective,
  ],
  standalone: true,
})
export class GeracaozCandidatureInscriptionComponent implements OnInit, AfterViewInit {
  programEnum?: ProgramEnum;
  programEnumLower?: string;
  mainImage?: string;
  mainBanner?: string;
  enum = ProgramEnum;
  mapLat = 39.69482724691313;
  mapLng = -8.130299785093573;
  zoom = 7;
  nameFilter?: string;
  locationFilter?: string;
  account?: Account | null;
  answers: IAnswer[] = [];
  answersList: any = {};
  person?: IPersonYoung;
  candidature?: ICandidatureFrontendGeracaoz;
  applied = false;
  activeEdition?: IProgramEdition;
  active = 1;
  isSaving = false;
  cols: any[] = [];
  colsLocation: any[] = [];
  selectedTasks: ITask[] = [];
  selectedLocations: ILocation[] = [];
  step3State = STEP_STATE.hidden;
  step2State = STEP_STATE.hidden;
  config: NgWizardConfig = {
    selected: 0,
    theme: THEME.arrows,
    lang: { next: 'Próximo', previous: 'Anterior' },
    toolbarSettings: {
      toolbarExtraButtons: [
        {
          text: 'Finalizar Inscrição',
          class: 'btn-pg btn-success',
          event: () => {
            this.submit();
          },
        },
      ],
    },
  };
  questions: IQuestion[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private sharedDataService: SharedDataService,
    private mapsApiLoader: MapsAPILoader,
    private registrationService: RegistrationService,
    private programEditionService: ProgramEditionService,
    private accountService: AccountService,
    private personService: PersonService,
    private questionService: QuestionService,
    private personValidatorService: PersonValidatorService,
    private notificationService: NotificationService,
    private ngWizardService: NgWizardService
  ) {
    this.cols = [
      { field: 'description', header: 'Descrição' },
      { field: 'schedule.startDate', header: 'De' },
      { field: 'schedule.endDate', header: 'Até' },
    ];
    this.colsLocation = [
      { field: 'designation', header: 'Local' },
      { field: 'address', header: 'Endereço' },
      { field: 'postalCode', header: 'Código Postal' },
      { field: 'locality', header: 'Localidade' },
      { field: 'county', header: 'Concelho' },
      { field: 'district', header: 'Distrito' },
    ];
  }

  showNextStep(): void {
    this.ngWizardService.next();
  }

  step2Valid(): boolean {
    this.answers = [];
    for (const key in this.answersList) {
      if (Object.prototype.hasOwnProperty.call(this.answersList, key)) {
        const answer = new Answer();
        answer.choiceId = this.answersList[key];
        answer.questionId = Number(key);
        this.answers.push(answer);
      }
    }
    if (this.answers.length !== this.questions.length) {
      this.notificationService.warning('Deves responder a todas as questões');
      return false;
    }
    return true;
  }

  step3Valid(): boolean {
    const result = this.selectedLocations.length > 0;
    if (!result) {
      this.notificationService.warning('Deves selecionar pelo menos uma localização');
    }
    return result;
  }

  ngOnInit(): void {
    this.programEditionService.query({ 'programEnum.equals': ProgramEnum.GERACAOZ }).subscribe(res => {
      const editions = res.body || [];
      if (editions && editions.length > 0) {
        this.activeEdition = editions[0];
      }
    });

    this.activatedRoute.data.subscribe(({ programEnum }) => {
      this.programEnum = programEnum;
      this.programEnumLower = (this.programEnum + '').toLowerCase();
      this.mainImage = '/content/images/' + this.programEnumLower + '/logotipo.png?cache=' + new Date().getMilliseconds();
      this.mainBanner = '/content/images/' + this.programEnumLower + '/front.png?cache=' + new Date().getMilliseconds();
    });

    this.candidature = this.sharedDataService.geracaozCandidature;
    if (this.candidature?.locations && this.candidature.locations.length > 1) {
      this.step3State = STEP_STATE.normal;
    }
    this.sharedDataService.geracaozCandidature = undefined;
    if (!this.candidature) {
      this.back();
    }
    if (this.candidature) {
      this.questionService.query({ 'candidatureId.equals': this.candidature.id }).subscribe(res => {
        this.questions = res.body || [];
        if (this.questions && this.questions.length > 1) {
          this.step2State = STEP_STATE.normal;
        }
      });
    }
    this.accountService.identity().subscribe(account => {
      this.account = account;
      if (this.account) {
        this.person = this.accountService.getPerson();
        if (this.person?.young) {
          this.registrationService
            .query({ 'youngId.equals': this.person.young.id, 'candidatureId.equals': this.candidature?.id })
            .subscribe(reg => {
              let applied = false;
              if (reg.body && reg.body.length > 0) {
                for (const regis of reg.body) {
                  if (
                    regis.state &&
                    (regis.state === YoungRegistrationState.REGISTERED ||
                      regis.state === YoungRegistrationState.SELECTED ||
                      regis.state === YoungRegistrationState.CONFIRMED)
                  ) {
                    applied = true;
                  }
                }
              }
              this.applied = applied;
            });
        }
      }
    });
  }

  getInstitutions(): IPersonToInstitutionEntityFunctionClient[] {
    return this.person?.institutions || [];
  }

  getSectorIdentifications(): ISectorIdentificationClient[] {
    return this.person?.sectorIdentifications || [];
  }

  getPortugueseAddress(): IPortugueseAddressClient[] {
    return this.person?.portugueseAddress || [];
  }

  getForeignAddress(): IForeignAddressClient[] {
    return this.person?.foreignAddress || [];
  }

  getPersonRelationships(): IPersonRelationshipClient[] {
    return this.person?.personActiveRelationships || [];
  }

  getLocations(): string {
    if (this.candidature?.locations) {
      let result = [];

      for (let i = 0; i < this.candidature.locations.length; i++) {
        if (this.candidature.locations[i].county) {
          result.push(this.candidature.locations[i].county);
        }
      }
      result = Array.from(new Set(result));
      return result.join(', ');
    }
    return '';
  }

  stepChanged(args: StepChangedArgs): void {
    if (args.step && args.step.index) {
      if (args.step.index !== 2) {
        const elements = document.getElementsByClassName('ng-wizard-btn-group-extra');
        for (let i = 0; i < elements.length; i++) {
          elements[i].setAttribute('style', 'display:none');
        }
      } else {
        if (args.step.index === 2) {
          const elements = document.getElementsByClassName('ng-wizard-btn-group-extra');
          for (let i = 0; i < elements.length; i++) {
            elements[i].setAttribute('style', 'display:block');
          }
        }
      }
      if (args.step.index === 2) {
        const elements = document.getElementsByClassName('ng-wizard-btn-next');
        for (let i = 0; i < elements.length; i++) {
          elements[i].setAttribute('style', 'display:none');
        }
      } else {
        const elements = document.getElementsByClassName('ng-wizard-btn-next');
        for (let i = 0; i < elements.length; i++) {
          elements[i].setAttribute('style', 'display:block');
        }
      }
      if (args.step.index === 0) {
        const elements = document.getElementsByClassName('ng-wizard-btn-prev');
        for (let i = 0; i < elements.length; i++) {
          elements[i].setAttribute('style', 'display:none');
        }
      } else {
        const elements = document.getElementsByClassName('ng-wizard-btn-prev');
        for (let i = 0; i < elements.length; i++) {
          elements[i].setAttribute('style', 'display:block');
        }
      }
    }
  }

  back(): void {
    void this.router.navigate(['geracaoz/acoes']);
  }

  getTasks(): ITask[] {
    return this.candidature?.tasks || [];
  }

  submit(): void {
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;
    if (this.person) {
      const errors = this.personValidatorService.validatePerson(this.person);
      if (errors.length > 0) {
        let errorsHTML = '';
        for (const error of errors) {
          errorsHTML += error + '<br>';
        }
        this.notificationService.candidatureSaveError('Perfil incompleto', errorsHTML);
        return;
      }
      if (
        this.personValidatorService.getAge(this.person) < (this.candidature?.parametrization?.minVolunteerAge || 0) ||
        this.personValidatorService.getAge(this.person) > (this.candidature?.parametrization?.maxVolunteerAge || 0)
      ) {
        this.notificationService.candidatureSaveError(
          'Idade',
          'O programa apenas permite a inscrição de jovens entre os ' +
            (this.candidature?.parametrization?.minVolunteerAge || 0) +
            ' e os ' +
            (this.candidature?.parametrization?.maxVolunteerAge || 0) +
            ' anos (inclusive)'
        );
        return;
      }
      const registration: IRegistration = new Registration();
      registration.answers = this.answers;
      registration.approvedMinorDeclaration = false;
      registration.candidatureId = this.candidature?.id;
      registration.confirmedFormationVisualization = false;
      registration.editionId = this.activeEdition?.id;
      registration.locations = this.selectedLocations;
      registration.registrationType = RegistrationType.CANDIDATURE;
      registration.state = YoungRegistrationState.REGISTERED;
      registration.tasks = this.selectedTasks;
      registration.youngId = this.person.young?.id;
      registration.youngBirthDate = this.person.person?.dateOfBirth;
      registration.youngSex = this.person.person?.sex;
      registration.youngCounty = this.personValidatorService.getAddress(this.person)?.countyName;
      registration.youngDistrict = this.personValidatorService.getAddress(this.person)?.districtName;
      registration.youngEmail = this.personValidatorService.getEmail(this.person);
      registration.youngHashCode = this.person.young?.hashCode;
      registration.youngIban = this.personValidatorService.getIban(this.person);
      registration.youngName = this.person.young?.name;
      registration.youngPhone = this.personValidatorService.getPhone(this.person);
      registration.youngVatNumber = this.person.young?.vatNumber;
      this.registrationService.create(registration).subscribe({
        next: () => {
          this.notificationService.success(
            'A tua inscrição foi submetida com sucesso. Aguarda por um contacto do IPDJ para os próximos passos.'
          );
          void this.router.navigate(['/']);
        },
        error: () => {
          this.isSaving = false;
          this.notificationService.error('Ocorreu um erro ao registar a tua inscrição. Por favor tenta mais tarde.');
        },
      });
    }
  }

  ngAfterViewInit(): void {
    const elements = document.getElementsByClassName('ng-wizard-btn-group-extra');
    for (let i = 0; i < elements.length; i++) {
      elements[i].setAttribute('style', 'display:none');
    }
    const elements1 = document.getElementsByClassName('ng-wizard-btn-next');
    for (let i = 0; i < elements1.length; i++) {
      elements1[i].setAttribute('style', 'display:block');
    }
    const elements2 = document.getElementsByClassName('ng-wizard-btn-prev');
    for (let i = 0; i < elements2.length; i++) {
      elements2[i].setAttribute('style', 'display:none');
    }
  }
}
